import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { DetailedIconUnlock, Flex, Spacer } from '@zillow/constellation';
import { Heading, Image, Modal, Paragraph, TextButton } from '@zillow/constellation-10';
import { ZillowInsuranceServicesLogo } from '@zillow/zrs-comet';

import propertyUtils from '../../../utils/propertyUtils';

import ModalFooter from '../ModalFooter';
import ChecklistDiamond from '../../../images/ChecklistDiamond.png';

import { ExpandableDisclaimer } from '@zillow/zrs-comet';
import { StyledFlex } from './StyledComponents';

const propTypes = { onClose: PropTypes.func.isRequired };
const defaultProps = {};

const RentGuaranteeActiveModal = ({ legalDisclaimer, coverageSummaryUrl, coverageAmount, onClose, onSubmit }) => {
  const { currentProperty } = useSelector((state) => state.properties);

  const { formattedAddress } = propertyUtils.formatAddress(currentProperty);

  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && onClose()}
      header={<ZillowInsuranceServicesLogo />}
      body={
        <Spacer padding={{ xs: 'xs', md: 'xl' }}>
          <Flex display="flex" alignItems="center" flexDirection="column" marginBottom="xs">
            <DetailedIconUnlock size="md" />
            <Heading level={4} fontFamily="serif">
              Your Rental Protection coverage is effective
            </Heading>
          </Flex>
          <Spacer marginX="xs">
            <Paragraph css={{ marginBottom: '400' }}>
              {`LeaseLock has confirmed that Rental Protection is in effect for ${formattedAddress}.`}
            </Paragraph>
            <StyledFlex display="flex" padding="sm" marginBottom="sm">
              <Spacer>
                <Image className="ChecklistDiamond" src={ChecklistDiamond} alt="checklist" />
              </Spacer>
              <Flex display="flex" flexDirection="column" alignItems="start">
                <Paragraph textStyle="body-bold">What&apos;s covered?</Paragraph>
                <Paragraph css={{ marginBottom: '400' }}>
                  Rental Protection provides up to {coverageAmount} of insurance coverage to help with some of the
                  situations your other insurance policies don&apos;t cover, like when tenants don&apos;t pay their
                  rent, or their puppy chews your unit&apos;s new carpet.
                </Paragraph>
                <TextButton asChild>
                  <a target="_blank" rel="noopener noreferrer" href={coverageSummaryUrl}>
                    See the coverage summary
                  </a>
                </TextButton>
              </Flex>
            </StyledFlex>
            {legalDisclaimer && (
              <ExpandableDisclaimer title="Coverage disclaimer" disclaimerContent={[legalDisclaimer]} />
            )}
          </Spacer>
        </Spacer>
      }
      footer={<ModalFooter submitText="OK" onSubmit={onSubmit} />}
      size={{ base: 'fullScreen', md: 'md' }}
    />
  );
};

RentGuaranteeActiveModal.propTypes = propTypes;
RentGuaranteeActiveModal.defaultProps = defaultProps;

export default RentGuaranteeActiveModal;
